import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { DialogContentText } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center',

        // paddingTop: 25,
        // paddingButton: 25,
        flex: 1,
    },
    margin: {
        marginTop: '15px',
    },
    buttonConfirm: {
        background: '#3364AF',
        width: '270px',
        height: '45px',
        // fontSize: '17px'
    },
    buttonCancel: {
        // background: '#3364AF',
        width: '270px',
        height: '45px',
        // fontSize: '17px'
    },
    labelCheckbox: {
        fontSize: '10px'
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '1rem',
        fontSize: '1.7rem',
        textAlign: 'center'
    },
    content: {
        marginLeft: '100px',
        marginRight: '100px',
        backgroundColor: 'whitesmoke'
    },
    pText: {
        margin: '30px',
        // fontSize: '13px'
    }

}));

export default function PolicyRegisterDialog(props) {
    const classes = useStyles();

    const { title, children, openPopup, setOpenPopup } = props;



    const onSubmit = e => {
        setOpenPopup(false);
      }

    const handleClose = () => {
        setOpenPopup(false);
    };


    return (

        <Dialog fullWidth={true} maxWidth={"lg"}
            open={openPopup}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >

            <DialogTitle id="alert-dialog-title" style={{
                // marginBottom: '1rem',
                marginTop: '2rem'
            }}>
                <Typography className={classes.title} >
                    เงื่อนไขข้อกำหนด
                                    </Typography>

            </DialogTitle>

            <DialogContentText className={classes.content}>
                <Typography className={classes.pText}>
                        ผู้ใช้บริการยินยอมให้กองเมล็ดพันธุ์ข้าวเข้าถึงข้อมูลส่วนบุคคลของผู้ใช้บริการเพื่อใช้ในการประมวลผลข้อมูลส่วนบุคคลของผู้ใช้บริการได้เท่าที่จำเป็นเพื่อประโยชน์ในการดำเนินการปรับปรุงการให้บริการรวมถึงการวิเคราะห์และการวางแผนทางการตลาด กิจกรรมทางการตลาดและกิจกรรมอื่นๆ อีกทั้งยินยอมให้ผู้บริการแจ้งข้อมูลข่าวสารในการส่งเสริมการขายและข้อเสนอต่างๆ เกี่ยวกับการสมัครและการซื้อขายสินค้าและบริการต่างๆ ของผู้ให้บริการตลอดจนการให้บริการใดๆที่ร่วมกับบุคคลอื่น ซึ่งรวมถึงยินยอมให้ผู้ให้บริการสามารถเปิดเผย ส่ง และโอนข้อมูลส่วนบุคคลของผู้ใช้บริการให้แก่บุคคลภายนอกได้
        </Typography>
        
            </DialogContentText>


            {/* <FormControlLabel style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px'
            }}
                    control={
                        <Checkbox
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label="ยอมรับเงื่อนไขข้อตกลงการสมัครสมาชิก"
                /> */}

            <DialogActions style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '20px',
                marginBottom: '20px'

            }}>
              

                <Button variant="outlined" className={classes.buttonCancel} color="primary" onClick={handleClose}>
                    ยกเลิก
                </Button>
                <Button variant="contained" type="submit" className={classes.buttonConfirm} onClick={onSubmit} color="primary"
                >ยืนยัน</Button>
            </DialogActions>


        </Dialog>

    );
}